import { createFileRoute, redirect } from '@tanstack/react-router';

// Visibility is Operations' Road view since 10 Oct 2026: an old link (a bookmark, a review's Back, a door in an old tab)
// lands there with everything it carried (`?playbook=`, `?stage=`, a creator open over the page…).
export const Route = createFileRoute('/_authed/visibility')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/operations', search: location.search as Record<string, never>, replace: true });
  },
});
